import agFetch from '../composer/utils/ag_fetch';

export type Method = 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';

export class ResponseError extends Error {
  response: Response;

  constructor(message: string, response: Response) {
    super(message);
    this.response = response;
    this.name = 'ResponseError';
  }
}

/**
 * Performs the `fetch` request but ensures that
 * CSRF token and proper `X-Requested-With` HTTP headers are
 * included as well. It also throws an error if `response.ok` is false.
 *
 * Note that any JSON response is not automatically parsed.
 * You need to call `response.json()` for that, or use `requestJson` instead.
 */
export default async function request(method: Method, url: string, payload?: unknown): Promise<Response> {
  const headers: HeadersInit = {};
  const hasJsonPayload = typeof payload !== 'undefined' && !(payload instanceof FormData);
  if (hasJsonPayload) {
    headers['Content-Type'] = 'application/json';
  }
  const response = await agFetch(url, {
    method,
    headers,
    body: hasJsonPayload ? JSON.stringify(payload) : payload,
  });
  if (!response.ok) {
    throw new ResponseError(`Request failed with status code ${response.status}`, response);
  }
  return response;
}
